
<template>
    <section class="content">
        <div class="container-fluid">
            <loader v-if="loading" :type="'table'"/>
            <div v-else>
                <div class="row">
                    <div class="col-12">
                    <h1>{{translate('messages.contact_form')}}</h1>
                    <p>{{translate('messages.contact_form_message')}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="sent" class="alert alert-success alert-dismissible">
                            <button type="button" class="close" data-dismiss="alert" aria-hidden="true"><i class="fas fa-times"></i></button>
                            <h5><i class="icon fas fa-check"></i> {{translate('messages.email_sent')}}</h5>
                            {{translate('messages.contact_sent')}}
                        </div>
                        <div class="card">
                            <div class="card-body">
                                
                                <form @submit.prevent="sendContactEmail" class="form-horizontal">
                                    <div class="form-group">
                                        <label for="inputName">{{translate('messages.name')}}</label>
                                        <input type="" v-model="form.name" class="form-control" id="inputName" :placeholder="translate('messages.name')" :class="{ 'is-invalid': form.errors.has('name') }">
                                        <has-error :form="form" field="name"></has-error>
                                        
                                    </div>
                                    <div class="form-group">
                                        <label for="inputEmail">{{translate('messages.email')}}</label>
                                            <input type="email" v-model="form.email" class="form-control" id="inputEmail" :placeholder="translate('messages.email')"  :class="{ 'is-invalid': form.errors.has('email') }">
                                            <has-error :form="form" field="email"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="inputMobilePhone">{{translate('messages.mobile_phone')}}</label>   
                                            <input type="text" v-model="form.mobile_phone" class="form-control" id="inputMobilePhone" :placeholder="translate('messages.mobile_phone')"  :class="{ 'is-invalid': form.errors.has('mobile_phone') }">
                                            <has-error :form="form" field="mobile_phone"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="inputMessage">{{translate('messages.message')}}</label>   
                                            <textarea rows="8" v-model="form.message" class="form-control" id="inputMessage" :placeholder="translate('messages.message')"  :class="{ 'is-invalid': form.errors.has('message') }"></textarea>
                                            <has-error :form="form" field="message"></has-error>
                                    </div>
                                    
                                    
                                    <div class="form-group">
                                        
                                        <button type="submit" class="btn btn-success">{{translate('messages.send')}}</button>
                                    
                                    </div>
                                </form>
                            </div><!-- /.card-body -->
                        </div>
                        <!-- /.nav-tabs-custom -->
                    </div>
                    <!-- end tabs -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                 form: new Form({
                    id:'',
                    name : '',
                    email: '',
                    mobile_phone: '',
                    message: ''
                }),
                loading : true,
                sent : false
            }
        },
        mounted() {
            
        },
        methods:{
            loadProfile(){
                axios.get("api/profile")
                .then(({ data }) => {
                    this.form.fill(data.data);
                    
                    this.loading = false;
                });
            },
            sendContactEmail(){
                this.$Progress.start();
                this.sent = false;
                this.form.post('api/profile/sendContactEmail')
                .then((data)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                    this.form.reset();
                    this.sent = true;
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });
            },

            
        },
        created() {
            this.loadProfile();
        }
    }
</script>
